<template>
  <div @mouseenter="hoverEvent" @mouseleave="hoverEvent" class="submit-button">
    <AppButtonMagenta
      v-on="$listeners"
      v-bind="$attrs"
      :class="{ loading: loading }"
      :inverted="invertedButtonColor"
    >
      <Spinner v-if="loading" :size="25" :color="spinnerColor" />
      <template v-else>
        <slot />
      </template>
    </AppButtonMagenta>
  </div>
</template>

<script>
// Components
import AppButtonMagenta from 'Ui/AppButtonMagenta'
import Spinner from 'Ui/AppSpinner'

export default {
  name: 'SubmitButton',

  inheritAttrs: false,
  components: {
    AppButtonMagenta,
    Spinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    spinnerColor: {
      type: String,
      default: 'var(--c-secondary-600)',
    },
    invertedButtonColor: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hoverEvent(event) {
      this.$emit('hoverEvent', event)
    },
  },
}
</script>

<style>
.submit-button {
  width: 152px;
}

.submit-button.disabled {
  cursor: not-allowed;
  pointer-events: all;
}

.submit-button .app-button {
  width: 100%;
}

.submit-button.disabled .app-button,
.app-button.loading {
  pointer-events: none;
}
</style>
